export const homepageConceptLocalStorageItem = 'homepageConcept';

export const HomepageConcepts = {
  CONCEPT_0: 'Concept 0',
  CONCEPT_1: 'Concept 1',
  CONCEPT_2: 'Concept 2',
};
